import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { fetchPartyCallDetailAllById } from "../../../Redux/Slice/Partycalldetails";
import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch";
import Cookies from "js-cookie";
import Loader from "../../../Components/Loader/Loader";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import defaultProfile from "../../../Image/Daynamic_Logo_Piture.png";

import {
  FaCalendarAlt,
  FaUserTie,
  FaCheckCircle,
  FaRegClock,
  FaBuilding,
  FaProjectDiagram,
  FaCogs,
  FaTags,
  FaPhoneAlt,
  FaRegUser,
} from "react-icons/fa";
import { MdOutlineDateRange, MdPersonOutline } from "react-icons/md";
import {
  HiOutlineDocumentText,
  HiOutlineInformationCircle,
} from "react-icons/hi";
import {
  BsClockHistory,
  BsFileEarmarkPdfFill,
  BsFileEarmarkImageFill,
  BsFileEarmarkTextFill,
  BsFileEarmarkWordFill,
  BsFileEarmarkExcelFill,
  BsFileEarmarkPlayFill,
  BsFileEarmarkMusicFill,
  BsFileEarmarkFill,
  BsFileEarmarkPptFill,
} from "react-icons/bs";
import { FiDownload, FiPaperclip, FiEye, FiExternalLink, FiList, FiActivity } from "react-icons/fi";
import { RiErrorWarningLine } from "react-icons/ri";

const formatDate = (dateString) => {
  if (!dateString) return "";
  const date = new Date(dateString);
  return isNaN(date.getTime())
    ? ""
    : date.toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    });
};

const formatDateTimeUTC = (dateString) => {
  if (!dateString) return "";
  const d = new Date(dateString);
  if (isNaN(d.getTime())) return "";

  try {
    const dateParts = new Intl.DateTimeFormat("en-IN", {
      timeZone: "Asia/Kolkata",
      day: "2-digit",
      month: "long",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      hour12: true
    }).formatToParts(d);

    const part = (type) => dateParts.find((p) => p.type === type)?.value || "";
    const day = part("day");
    const month = part("month");
    const year = part("year");
    const hour = part("hour");
    const minute = part("minute");
    const dayPeriod = (part("dayPeriod") || "").toUpperCase();

    return `${day} ${month} ${year}, ${hour}:${minute} ${dayPeriod}`;
  } catch (e) {
    return d.toLocaleString("en-IN", { timeZone: "Asia/Kolkata" });
  }
};

const DeveloperAvatar = ({ photo, name, size = "w-8 h-8" }) => {
  const [hasError, setHasError] = useState(false);

  const getInitials = (n) => {
    if (!n) return "DV";
    const parts = n.trim().split(/\s+/);
    if (parts.length >= 2) {
      return (parts[0][0] + parts[1][0]).toUpperCase();
    }
    return n.slice(0, 2).toUpperCase();
  };

  if (photo && !hasError) {
    return (
      <img
        src={photo}
        alt={name || "Developer"}
        className={`${size} rounded-full object-cover shrink-0 border border-slate-200 shadow-sm`}
        onError={() => setHasError(true)}
      />
    );
  }

  return (
    <div
      className={`${size} rounded-full shrink-0 border border-slate-300 bg-gradient-to-br from-blue-100 to-indigo-100 text-[#112A47] flex items-center justify-center text-[11px] font-bold tracking-tight uppercase shadow-sm`}
    >
      {getInitials(name)}
    </div>
  );
};

const ComplaintDetailPage = () => {
  const loginData = Cookies.get("loginData");
  const parsedData = loginData ? JSON.parse(loginData) : null;
  const dispatch = useDispatch();
  const { id } = useParams();

  const { selectedPartyCallDetailAll, loading: complainIdLoading } = useSelector(
    (state) => state.partyCall,
  );

  const [selectedPhoto, setSelectedPhoto] = useState(null);
  const [complaintData, setComplaintData] = useState(null);
  const [isInitialLoading, setIsInitialLoading] = useState(true);

  useEffect(() => {
    const loadData = async () => {
      setIsInitialLoading(true);
      try {
        if (id) {
          await dispatch(fetchPartyCallDetailAllById(id));
        }
      } finally {
        setIsInitialLoading(false);
      }
    };
    loadData();
  }, [dispatch, id]);

  useEffect(() => {
    if (selectedPartyCallDetailAll && selectedPartyCallDetailAll?.data) {
      const apiData = selectedPartyCallDetailAll?.data;
      const validPhotos = (apiData?.Photos || []).filter((url) => url);

      setComplaintData({
        date: apiData.Date,
        callNo: apiData.CallNo,
        company: apiData.CompanyName?.WhaClientName || apiData.CompanyName?.CompanyName || "-",
        project: apiData.Project?.project_name || "-",
        module:
          apiData.Module?.ModuleName || apiData.Module?.module_name || "-",
        type:
          apiData.Type?.Type_name ||
          apiData.Type?.TypeName ||
          apiData.Type?.type_name ||
          apiData.Requirement_Type ||
          "-",
        presentStatus: apiData.PresentStatus || "-",
        requirement: apiData.Requirement || "-",
        solution: apiData.Solution || "-",
        benefit: apiData.Benefit || "-",
        employee: apiData.Employee || "-",
        status: apiData.Status || "-",
        Partition: apiData.Partition || "-",
        ContactPerName: apiData.ContactPerName || "-",
        ContactPer: apiData.ContactPer || "-",
        photos: validPhotos.map((url, idx) => ({
          id: `photo-${idx}`,
          title: `Attachment ${idx + 1}`,
          file: url,
        })),
        records: (apiData.Record || []).map((rec) => {
          const emp = rec.InHouseId;
          const hasEmp = emp && typeof emp === "object" && emp.Name;
          const fallbackMember = apiData.SuportTeamId || apiData.SeniorDevloperID || apiData.InPutId;
          const targetUser = hasEmp ? emp : fallbackMember;

          const partyName =
            targetUser?.Name ||
            apiData.CompanyName?.WhaClientName ||
            "Team Member";
          const role =
            targetUser?.Role ||
            "Team Member";
          // Only use targetUser's own profile photo if present and non-empty. Never fall back to another developer's photo!
          const profilePhoto =
            (targetUser?.ProfilePhoto && typeof targetUser.ProfilePhoto === "string" && targetUser.ProfilePhoto.trim())
              ? targetUser.ProfilePhoto.trim()
              : null;

          return {
            id: rec._id,
            partyName,
            Role: role,
            profilePhoto,
            description: rec.DescripTione || "No description provided.",
            date: rec.Date,
            status:
              typeof rec.Status === "string"
                ? rec.Status.replace(/\.$/, "").trim()
                : rec.Status || "",
          };
        }),
      });
    } else {
      setComplaintData(null);
    }
  }, [selectedPartyCallDetailAll]);

  const openPhotoModal = (photo) => setSelectedPhoto(photo);
  const closePhotoModal = () => setSelectedPhoto(null);

  const detectExtension = (fileUrl = "", mimeType = "") => {
    const raw = String(fileUrl).split("?")[0].toLowerCase();
    if (raw.includes(".vnd.ms-excel") || raw.endsWith(".xls")) return "xls";
    if (raw.includes("spreadsheetml") || raw.endsWith(".xlsx")) return "xlsx";
    if (raw.includes("wordprocessingml") || raw.endsWith(".docx")) return "docx";
    if (raw.includes(".msword") || raw.endsWith(".doc")) return "doc";
    if (raw.includes(".presentationml") || raw.endsWith(".pptx")) return "pptx";
    if (raw.includes(".powerpoint") || raw.endsWith(".ppt")) return "ppt";
    if (raw.endsWith(".pdf")) return "pdf";
    if (raw.endsWith(".csv")) return "csv";
    if (raw.endsWith(".txt")) return "txt";
    if (raw.endsWith(".png")) return "png";
    if (raw.endsWith(".jpg") || raw.endsWith(".jpeg")) return "jpg";
    if (raw.endsWith(".webp")) return "webp";
    if (raw.endsWith(".gif")) return "gif";
    if (raw.endsWith(".svg")) return "svg";
    if (raw.endsWith(".mp4")) return "mp4";
    if (raw.endsWith(".webm")) return "webm";
    if (raw.endsWith(".mp3")) return "mp3";
    if (raw.endsWith(".wav")) return "wav";
    if (raw.endsWith(".zip")) return "zip";
    if (raw.endsWith(".rar")) return "rar";

    if (mimeType) {
      const mime = mimeType.toLowerCase();
      if (mime.includes("ms-excel") || mime.includes("excel")) return "xls";
      if (mime.includes("spreadsheetml")) return "xlsx";
      if (mime.includes("wordprocessingml")) return "docx";
      if (mime.includes("msword")) return "doc";
      if (mime.includes("presentation") || mime.includes("powerpoint")) return "pptx";
      if (mime.includes("pdf")) return "pdf";
      if (mime.includes("csv")) return "csv";
      if (mime.includes("text/plain")) return "txt";
      if (mime.includes("image/png")) return "png";
      if (mime.includes("image/jpeg")) return "jpg";
      if (mime.includes("image/webp")) return "webp";
      if (mime.includes("image/gif")) return "gif";
      if (mime.includes("image/svg")) return "svg";
      if (mime.includes("video/mp4")) return "mp4";
      if (mime.includes("audio/mpeg") || mime.includes("audio/mp3")) return "mp3";
      if (mime.includes("zip")) return "zip";
    }

    const lastDot = raw.lastIndexOf(".");
    if (lastDot !== -1 && lastDot < raw.length - 1) {
      const candidate = raw.substring(lastDot + 1);
      if (candidate.length <= 5 && /^[a-z0-9]+$/.test(candidate)) {
        return candidate;
      }
    }
    return "bin";
  };

  const getFileType = (file) => {
    if (!file) return "unknown";

    if (typeof file === "string" && file.startsWith("data:")) {
      const mime = file.split(";")[0].replace("data:", "").toLowerCase();
      if (mime.startsWith("image/")) return "image";
      if (mime === "application/pdf") return "pdf";
      if (mime.includes("excel") || mime.includes("spreadsheetml") || mime.includes("ms-excel")) return "excel";
      if (mime.includes("word") || mime.includes("msword") || mime.includes("wordprocessingml")) return "word";
      if (mime.includes("presentation") || mime.includes("powerpoint")) return "powerpoint";
      if (mime.includes("csv")) return "csv";
      if (mime.includes("text")) return "text";
      if (mime.startsWith("video/")) return "video";
      if (mime.startsWith("audio/")) return "audio";
      return "file";
    }

    if (typeof file === "string") {
      const ext = detectExtension(file);
      const imageExts = ["jpg", "jpeg", "png", "gif", "bmp", "webp", "svg"];
      if (imageExts.includes(ext)) return "image";
      if (ext === "pdf") return "pdf";
      if (["xls", "xlsx"].includes(ext)) return "excel";
      if (["doc", "docx"].includes(ext)) return "word";
      if (["ppt", "pptx"].includes(ext)) return "powerpoint";
      if (ext === "csv") return "csv";
      if (ext === "txt") return "text";
      if (["mp4", "webm", "mkv", "mov"].includes(ext)) return "video";
      if (["mp3", "wav", "ogg", "aac"].includes(ext)) return "audio";
      return "file";
    }

    return "unknown";
  };

  const getFileIconComponent = (type) => {
    switch (type) {
      case "pdf":
        return BsFileEarmarkPdfFill;
      case "image":
        return BsFileEarmarkImageFill;
      case "word":
        return BsFileEarmarkWordFill;
      case "excel":
      case "csv":
        return BsFileEarmarkExcelFill;
      case "powerpoint":
        return BsFileEarmarkPptFill;
      case "text":
        return BsFileEarmarkTextFill;
      case "video":
        return BsFileEarmarkPlayFill;
      case "audio":
        return BsFileEarmarkMusicFill;
      default:
        return BsFileEarmarkFill;
    }
  };

  const getFileColorClass = (type) => {
    switch (type) {
      case "pdf":
        return "text-red-500 bg-red-100";
      case "image":
        return "text-blue-500 bg-blue-100";
      case "word":
        return "text-blue-700 bg-blue-100";
      case "excel":
        return "text-emerald-700 bg-emerald-100";
      case "csv":
        return "text-green-700 bg-green-100";
      case "powerpoint":
        return "text-orange-600 bg-orange-100";
      case "text":
        return "text-gray-600 bg-gray-100";
      case "video":
        return "text-purple-500 bg-purple-100";
      case "audio":
        return "text-yellow-600 bg-yellow-100";
      default:
        return "text-gray-600 bg-gray-100";
    }
  };

  const handleDownload = async (fileUrl, fileName) => {
    if (!fileUrl) return;
    try {
      toast.info("Downloading attachment...");
      const fetchUrl = fileUrl + (fileUrl.includes("?") ? "&" : "?") + "bypassConfig=true&time=" + Date.now();

      const response = await fetch(fetchUrl, {
        method: "GET",
        mode: "cors"
      });

      if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);

      const blob = await response.blob();
      const detectedExt = detectExtension(fileUrl, blob.type);
      const blobUrl = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = blobUrl;

      let baseName = fileName || "attachment";
      if (baseName.includes(".")) {
        const parts = baseName.split(".");
        const currentExt = parts[parts.length - 1].toLowerCase();
        if (["vnd", "ms-excel", "bin", "octet-stream"].includes(currentExt) || currentExt.length > 5) {
          parts.pop();
          baseName = parts.join(".");
        }
      }
      const safeFileName = baseName.includes(".") ? baseName : `${baseName}.${detectedExt}`;

      link.download = safeFileName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(blobUrl);
      toast.success("Download started!");
    } catch (error) {
      console.error("Direct download failed, opening in new tab:", error);
      window.open(fileUrl, "_blank");
      toast.warning("Opening file in new tab...");
    }
  };

  if (
    isInitialLoading ||
    complainIdLoading ||
    !complaintData
  ) {
    return <Loader />;
  }

  return (
    <div className="md:p-2 min-h-screen">

      <div className="max-w-8xl mx-auto">
        {/* Header Card Sticky background wrapper to hide scrolling content */}
        <div className="sticky top-0 z-10 -mt-4 md:-mt-2 -mx-2 md:-mx-2 pt-4 md:pt-2 px-4 md:px-2 pb-4 bg-gray-100 backdrop-blur-sm mb-2">
          <div className="bg-[#101828] text-white p-5 md:p-6 rounded-xl shadow-lg flex flex-col md:flex-row justify-between items-start md:items-center relative overflow-hidden">
            <div className="flex w-full justify-between items-start md:items-center flex-col md:flex-row gap-4">
              <div>
                <h3 className="text-xl md:text-2xl font-bold mb-1 tracking-tight">
                  Customer Requirement Details
                </h3>
                <p className="text-[13px] md:text-sm text-gray-400 mb-4 font-medium flex items-center gap-2">
                  Internal Call / Task Resolution Workflow System
                </p>
                <div className="flex flex-wrap items-center gap-3 text-xs md:text-sm">
                  <span className="flex items-center gap-1.5 text-gray-300 font-medium bg-white/5 py-1 px-3 rounded text-xs">
                    <FaCalendarAlt className="text-blue-400" />
                    {formatDate(complaintData?.date) || "-"} -{" "}
                    {complaintData?.records?.length > 0
                      ? formatDate(complaintData.records[complaintData.records.length - 1].date) || formatDate(new Date())
                      : formatDate(new Date())}
                  </span>
                  <span className={`flex items-center gap-1.5 px-3 py-1 rounded text-xs font-bold border ${["completed", "accept"].includes(complaintData?.status?.toLowerCase())
                    ? "bg-[#027A48]/20 text-[#12B76A] border-[#027A48]/30"
                    : "bg-[#3f64ff]/20 text-[#3f64ff] border-[#3f64ff]/30"
                    }`}>
                    <FaCheckCircle />
                    {(() => {
                      if (!complaintData?.date) return '0 Days';

                      const start = new Date(complaintData.date);
                      let end = new Date();

                      // Use the date from the last record, if available
                      if (complaintData?.records?.length > 0) {
                        end = new Date(complaintData.records[complaintData.records.length - 1].date);
                      }

                      // Calculate the difference in time and days
                      const diffTime = Math.abs(end - start);
                      const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));
                      const finalDays = diffDays === 0 ? 1 : diffDays;

                      const st = complaintData?.status?.toLowerCase();
                      if (st === "completed") return `${finalDays} Days (Completed)`;
                      if (st === "accept") return `${finalDays} Days (Accepted)`;
                      return `${finalDays} Days`;
                    })()}
                  </span>
                  <span className={`flex items-center gap-1.5 px-3 py-1 rounded text-xs font-bold border ${(() => {
                    const statusVal = complaintData?.status?.toLowerCase() || '';
                    if (statusVal === "completed" || statusVal === "accept") return "bg-[#027A48]/20 text-[#12B76A] border-[#027A48]/30";
                    if (statusVal === "hold") return "bg-[#f59e0b]/20 text-[#f59e0b] border-[#f59e0b]/30";
                    if (statusVal === "pending" || statusVal === "assigned") return "bg-[#3f64ff]/20 text-[#3f64ff] border-[#3f64ff]/30";
                    if (statusVal === "in progress" || statusVal === "running") return "bg-[#06b6d4]/20 text-[#06b6d4] border-[#06b6d4]/30";
                    return "bg-[#ef4444]/20 text-[#ef4444] border-[#ef4444]/30";
                  })()} capitalize`}>
                    Status: {complaintData?.status || "-"}
                  </span>
                </div>
              </div>

              <div className="shrink-0 md:mt-0 mt-4 flex flex-col items-start md:items-end gap-4 w-full md:w-auto">
                <div className="flex items-center gap-3 mb-1 w-full md:w-auto justify-start">
                  <span className="bg-[#fff3cd] text-[#856404] px-4 md:px-5 py-1.5 md:py-2 rounded-lg text-base md:text-lg font-bold shadow-md border border-[#ffeeba] tracking-wide inline-flex items-center">
                    #{complaintData?.callNo || "-"}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Complaint Details Widget */}
        <div className="bg-white p-5 md:p-6 rounded-xl shadow-sm border border-gray-200 mb-6">
          <div className="flex items-center justify-between mb-5 border-b border-gray-100 pb-3">
            <div className="flex items-center gap-2">
              <HiOutlineDocumentText className="text-gray-500 text-lg" />
              <h2 className="text-base md:text-lg font-bold text-gray-800">
                Complaint Details
              </h2>
            </div>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-3 lg:grid-cols-5 gap-x-4 gap-y-5">
            <DetailInput
              icon={<MdOutlineDateRange />}
              label="Date"
              value={formatDate(complaintData?.date)}
            />
            <DetailInput
              icon={<FaTags />}
              label="Type"
              value={complaintData?.type}
            />
            <DetailInput
              icon={<FaBuilding />}
              label="Company"
              value={complaintData?.company}
            />
            <DetailInput
              icon={<FaProjectDiagram />}
              label="Project"
              value={complaintData?.project}
            />
            <DetailInput
              icon={<FaCogs />}
              label="Module"
              value={complaintData?.module}
            />
          </div>
        </div>

        {/* Status & Support Widget */}
        <div className="bg-white p-5 md:p-6 rounded-xl shadow-sm border border-gray-200 mb-6">
          <div className="flex items-center gap-2 mb-5 border-b border-gray-100 pb-3">
            <FaCheckCircle className="text-blue-500 text-base" />
            <h2 className="text-base md:text-lg font-bold text-gray-800">
              Status & Support
            </h2>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-12 gap-6">
            <div className="lg:col-span-8 grid grid-cols-1 sm:grid-cols-2 gap-4">
              <DetailTextarea
                label="Present Status"
                value={complaintData?.presentStatus}
              />
              <DetailTextarea
                label="Requirement"
                value={complaintData?.requirement}
              />
              <DetailTextarea
                label="Solution"
                value={complaintData?.solution}
              />
              <DetailTextarea label="Benefits" value={complaintData?.benefit} />
            </div>

            <div className="lg:col-span-4 rounded-xl h-full">
              <h3 className="text-[12px] font-bold text-gray-500 mb-2 flex items-center gap-1.5 uppercase tracking-wide">
                <FiPaperclip className="text-gray-400" />
                Attachments ({complaintData?.photos?.length || 0})
              </h3>

              <div className="flex flex-col gap-2 max-h-[300px] overflow-y-auto custom-scrollbar">
                {complaintData?.photos?.length > 0 ? (
                  complaintData.photos.map((photo, index) => {
                    const fileType = getFileType(photo.file);
                    const colorClass = getFileColorClass(fileType);

                    return (
                      <div
                        key={photo.id}
                        className="flex items-center justify-between p-2.5 bg-white border border-gray-200 rounded-lg hover:border-blue-300 transition-all cursor-pointer group shadow-sm"
                        onClick={() => openPhotoModal(photo)}
                      >
                        <div className="flex items-center gap-3 overflow-hidden">
                          <div
                            className={`p-2 rounded ${colorClass}`}
                          >
                            {(() => {
                              const IconComp = getFileIconComponent(fileType);
                              return <IconComp className="text-lg" />;
                            })()}
                          </div>
                          <div className="overflow-hidden">
                            <p className="text-xs font-bold text-gray-700 truncate w-32 md:w-40 group-hover:text-blue-600">
                              {photo.title}
                            </p>
                            <p className="text-[10px] text-gray-400 capitalize mt-0.5">
                              {fileType} Document
                            </p>
                          </div>
                        </div>
                        <div
                          className="p-1.5 text-blue-500 hover:bg-blue-50 rounded transition-colors group-hover:scale-110"
                        >
                          <FiEye size={14} />
                        </div>
                      </div>
                    );
                  })
                ) : (
                  <div className="text-center py-8 text-gray-400 text-xs flex flex-col items-center justify-center bg-gray-50 rounded-lg border border-dashed border-gray-200">
                    <FiPaperclip className="text-2xl mb-2 text-gray-300" />
                    <p className="font-medium">No attachments</p>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>

        {/* Contact Details Widget */}
        <div className="bg-white p-5 md:p-6 rounded-xl shadow-sm border border-gray-200 mb-6">
          <div className="flex items-center gap-2 mb-5 border-b border-gray-100 pb-3">
            <FaRegUser className="text-green-600 text-base" />
            <h2 className="text-base md:text-lg font-bold text-gray-800">
              Contact Details
            </h2>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-3 lg:grid-cols-4 gap-4 ">
            <DetailInput label="Post By" value={complaintData?.Partition} />
            <DetailInput
              label="Contact Name"
              value={complaintData?.ContactPerName}
            />
            <DetailInput
              label="Contact No."
              value={complaintData?.ContactPer}
            />
            <DetailInput label="Employee" value={complaintData?.employee} />
          </div>
        </div>

        {/* Task Resolution Timeline */}
        <div className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden mb-8">
          <div className="bg-[#4f46e5] text-white p-4 sm:p-5 flex items-center justify-between">
            <div>
              <div className="flex items-center gap-2 mb-0.5">
                <BsClockHistory className="text-base sm:text-lg" />
                <h2 className="text-base md:text-lg font-bold tracking-wide">
                  Task Resolution Timeline
                </h2>
              </div>
              <p className="text-indigo-200 text-[12px] font-medium ml-6">
                Cross-lined escalation workflow + Zig-zag view
              </p>
            </div>
            {complaintData?.records?.length > 0 && (
              <span className="bg-white/15 backdrop-blur-sm border border-white/20 text-white text-xs font-bold px-3 py-1 rounded-full">
                {complaintData.records.length} {complaintData.records.length === 1 ? "Step" : "Steps"}
              </span>
            )}
          </div>

          <div className="p-4 sm:p-6 bg-white shrink-0 w-full max-h-[600px] overflow-y-auto overflow-x-hidden custom-scrollbar">
            {complaintData?.records?.length > 0 ? (
              <div className="relative wrap py-3">
                {/* Vertical Timeline Line */}
                <div className="absolute h-full w-[2px] bg-slate-200 left-[24px] md:left-1/2 md:-ml-[1px] top-0"></div>

                {complaintData.records.map((rec, index) => {
                  const isEven = index % 2 === 0;
                  const colors = [
                    {
                      border: "border-green-500",
                      stepBg: "bg-green-600",
                      badgeBg: "bg-gray-900",
                      badgeText: "text-white",
                      badgeLabel: "Completed",
                      dot: "border-green-500",
                      iconText: "text-green-500",
                      commentBg: "bg-green-50/70",
                      Icon: FaCheckCircle,
                    },
                    {
                      border: "border-blue-500",
                      stepBg: "bg-blue-600",
                      badgeBg: "bg-blue-600",
                      badgeText: "text-white",
                      badgeLabel: "Assigned",
                      dot: "border-blue-500",
                      iconText: "text-blue-500",
                      commentBg: "bg-blue-50/70",
                      Icon: FaCheckCircle,
                    },
                    {
                      border: "border-orange-500",
                      stepBg: "bg-orange-500",
                      badgeBg: "bg-[#e11d48]",
                      badgeText: "text-white",
                      badgeLabel: "Changes Requested",
                      dot: "border-orange-500",
                      iconText: "text-orange-500",
                      commentBg: "bg-orange-50/70",
                      Icon: HiOutlineInformationCircle,
                    },
                    {
                      border: "border-purple-500",
                      stepBg: "bg-purple-600",
                      badgeBg: "bg-purple-100",
                      badgeText: "text-purple-800",
                      badgeLabel: "In Review",
                      dot: "border-purple-500",
                      iconText: "text-purple-500",
                      commentBg: "bg-purple-50/70",
                      Icon: FaRegClock,
                    },
                    {
                      border: "border-rose-500",
                      stepBg: "bg-rose-600",
                      badgeBg: "bg-rose-100",
                      badgeText: "text-rose-800",
                      badgeLabel: "Urgent",
                      dot: "border-rose-500",
                      iconText: "text-rose-500",
                      commentBg: "bg-rose-50/70",
                      Icon: HiOutlineInformationCircle,
                    },
                    {
                      border: "border-teal-500",
                      stepBg: "bg-teal-600",
                      badgeBg: "bg-teal-100",
                      badgeText: "text-teal-800",
                      badgeLabel: "Testing",
                      dot: "border-teal-500",
                      iconText: "text-teal-500",
                      commentBg: "bg-teal-50/70",
                      Icon: FaRegClock,
                    },
                    {
                      border: "border-indigo-500",
                      stepBg: "bg-indigo-600",
                      badgeBg: "bg-indigo-100",
                      badgeText: "text-indigo-800",
                      badgeLabel: "Pending",
                      dot: "border-indigo-500",
                      iconText: "text-indigo-500",
                      commentBg: "bg-indigo-50/70",
                      Icon: FaRegClock,
                    }
                  ];
                  const color = colors[index % colors.length];

                  return (
                    <div
                      key={rec.id || index}
                      className={`mb-6 flex justify-between items-start w-full relative group ${
                        isEven ? "md:flex-row-reverse" : ""
                      }`}
                    >
                      <div className="hidden md:block w-[calc(50%-28px)]"></div>

                      {/* Timeline Dot container */}
                      <div
                        className={`absolute left-[24px] md:left-1/2 mt-[40px] z-10 flex items-center justify-center -ml-[8px]`}
                      >
                        <div
                          className={`w-4 h-4 rounded-full bg-white border-4 ${color.dot} shadow-sm transition-transform duration-300 group-hover:scale-125`}
                        ></div>
                      </div>

                      {/* Horizontal connecting line - Mobile */}
                      <div className="absolute left-[31px] mt-[47px] w-[17px] h-[2px] bg-slate-300 md:hidden z-0"></div>

                      {/* Horizontal connecting line - Desktop */}
                      <div
                        className={`absolute top-[47px] w-[28px] h-[2px] bg-slate-300 hidden md:block z-0 ${
                          isEven
                            ? "left-[calc(50%-28px)]"
                            : "right-[calc(50%-28px)]"
                        }`}
                      ></div>

                      <div className={`w-full pl-[48px] md:w-[calc(50%-28px)] md:pl-0 flex flex-col pt-1`}>
                        {/* Step Badge & Status Pill */}
                        <div className={`mb-2.5 z-4 flex items-center gap-2 flex-wrap`}>
                          <span className={`inline-flex items-center justify-center ${color.stepBg} text-[11px] sm:text-[12px] px-3.5 py-1 rounded-full font-bold text-white shadow-sm whitespace-nowrap tracking-wide`}>
                            Step {index + 1}
                          </span>
                          {rec.status && (
                            <span className="inline-flex items-center gap-1.5 px-3 py-0.5 rounded-full text-[11px] font-bold border border-blue-200 bg-blue-50 text-blue-700 shadow-2xs">
                              <span className="w-1.5 h-1.5 rounded-full bg-blue-500"></span>
                              <span>{rec.status}</span>
                            </span>
                          )}
                        </div>
                        <div className={`${color.commentBg} border border-l-[6px] rounded-2xl ${color.border} shadow-sm hover:shadow-md p-4 sm:p-5 transition-all duration-300 relative`}>

                          {/* Header section with Avatar, Name, and Date */}
                          <div className="flex flex-wrap items-start justify-between w-full mb-3 gap-y-2 gap-x-4">
                            <div className="flex items-center gap-3 w-full xl:w-auto flex-1 min-w-[200px]">
                              <DeveloperAvatar
                                photo={rec.profilePhoto}
                                name={rec.partyName}
                                size="w-10 h-10 sm:w-11 sm:h-11"
                              />
                              <div className="flex-1 min-w-0">
                                <h3 className="font-bold text-slate-800 text-[13px] sm:text-[14px] leading-tight break-words">
                                  {rec.partyName}
                                </h3>
                                <p className="text-[11px] text-slate-500 font-semibold whitespace-nowrap mt-0.5">
                                  {rec.Role || "Team Member"}
                                </p>
                              </div>
                            </div>
                            <div className="w-full xl:w-auto flex items-center justify-start xl:justify-end gap-2 mt-1 xl:mt-0 shrink-0 flex-wrap">
                              {rec.status && (
                                <span className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-lg text-[11px] font-bold border border-blue-200 bg-white/90 text-blue-700 shadow-2xs">
                                  <span className="w-1.5 h-1.5 rounded-full bg-blue-500"></span>
                                  <span>{rec.status}</span>
                                </span>
                              )}
                              <div className="flex items-center gap-1.5 text-[11px] text-slate-600 font-bold whitespace-nowrap bg-white/80 px-2.5 py-1.5 rounded-lg border border-slate-200/60 shadow-xs">
                                <FaRegClock className="text-slate-400 shrink-0 text-xs" />
                                <span className="truncate">
                                  {formatDateTimeUTC(rec.date)}
                                </span>
                              </div>
                            </div>
                          </div>

                          {/* Inner white block containing the main descriptions */}
                          <div className="bg-white rounded-xl p-4 shadow-sm border border-slate-100 mt-2">
                            {rec.status && (
                              <div className="mb-2 pb-2 border-b border-slate-100 flex items-center justify-between gap-2 flex-wrap">
                                <p className="text-[10px] uppercase tracking-wider font-extrabold text-slate-400 mb-0">
                                  Status:
                                </p>
                                <span className="inline-flex items-center gap-1.5 px-2.5 py-0.5 rounded-md text-xs font-bold border border-blue-200 bg-blue-50 text-blue-700">
                                  <span className="w-1.5 h-1.5 rounded-full bg-blue-500"></span>
                                  <span>{rec.status}</span>
                                </span>
                              </div>
                            )}
                            <p className="text-[10px] uppercase tracking-wider font-extrabold text-slate-400 mb-1.5">
                              Description:
                            </p>
                            <div className="text-[12px] sm:text-[13px] text-slate-800 leading-relaxed font-bold mb-2 pb-2.5 border-b border-slate-100">
                              {complaintData?.requirement || "No requirement specified."}
                            </div>
                            <div className="text-[12px] text-slate-600 leading-relaxed font-medium">
                              {rec.description}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            ) : (
              <div className="text-center py-12 bg-white rounded-xl border border-dashed border-gray-200">
                <div className="w-16 h-16 bg-gray-50 rounded-full flex items-center justify-center mx-auto mb-3">
                  <RiErrorWarningLine className="text-3xl text-gray-300" />
                </div>
                <p className="text-gray-500 text-sm font-medium">
                  No timeline records available.
                </p>
              </div>
            )}
          </div>
        </div>
      </div>

      {/* Modals remain mostly similar to original, improved visually slightly */}
      {
        selectedPhoto && (
          <div
            className="fixed inset-0 bg-gray-900/90 backdrop-blur-sm flex items-center justify-center z-[9999] p-4"
            onClick={closePhotoModal}
          >
            <div
              className="relative max-w-[95vw] max-h-[95vh] overflow-hidden bg-white rounded-2xl shadow-2xl flex flex-col"
              onClick={(e) => e.stopPropagation()}
            >
              <div className="flex justify-between items-center p-4 border-b bg-gray-50">
                <div className="flex items-center gap-3">
                  <div className="p-2 bg-blue-100 text-blue-600 rounded-lg">
                    {(() => {
                      const fileType = getFileType(selectedPhoto.file);
                      const IconComp = getFileIconComponent(fileType);
                      return <IconComp className="text-xl" />;
                    })()}
                  </div>
                  <div>
                    <h3 className="font-bold text-gray-800">
                      {selectedPhoto.title}
                    </h3>
                    <p className="text-xs text-gray-500 capitalize">
                      {getFileType(selectedPhoto.file)} File
                    </p>
                  </div>
                </div>
                <div className="flex items-center gap-2 sm:gap-4">
                  <a
                    href={selectedPhoto.file}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-gray-600 hover:text-gray-800 font-semibold flex items-center gap-1.5 text-[12px] sm:text-sm bg-gray-100 hover:bg-gray-200 px-3 py-1.5 rounded-lg transition-colors border border-gray-200 shadow-sm"
                    title="Open directly in new tab"
                  >
                    <FiExternalLink className="text-base" /> <span className="hidden sm:inline">Open in Tab</span>
                  </a>
                  <button
                    onClick={() => handleDownload(selectedPhoto.file, selectedPhoto.title)}
                    className="text-blue-600 hover:text-blue-700 font-semibold flex items-center gap-1.5 text-[12px] sm:text-sm bg-blue-50 hover:bg-blue-100 px-3 py-1.5 rounded-lg transition-colors border border-blue-100 shadow-sm"
                  >
                    <FiDownload className="text-base" /> <span className="hidden sm:inline">Download</span>
                  </button>
                  <button
                    onClick={closePhotoModal}
                    className="text-gray-500 hover:text-red-600 hover:bg-red-50 p-2 rounded-full transition-colors text-2xl leading-none"
                  >
                    &times;
                  </button>
                </div>
              </div>

              <div className="p-6 overflow-auto bg-gray-100 flex-1 flex items-center justify-center min-h-[50vh]">
                {(() => {
                  const fileType = getFileType(selectedPhoto.file);

                  return (
                    <>
                      {fileType === "image" && (
                        <TransformWrapper
                          initialScale={1}
                          minScale={0.5}
                          maxScale={10}
                          centerOnInit={true}
                        >
                          <TransformComponent>
                            <img
                              src={selectedPhoto.file}
                              alt={selectedPhoto.title}
                              className="max-h-[70vh] max-w-full mx-auto rounded-lg shadow-md"
                              onError={(e) => {
                                e.target.onerror = null;
                                e.target.src =
                                  "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='400' height='300' viewBox='0 0 24 24'%3E%3Cpath fill='%23999' d='M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-4.86 8.86l-3 3.87L9 13.14L6 17h12l-3.86-5.14z'/%3E%3C/svg%3E";
                              }}
                            />
                          </TransformComponent>
                        </TransformWrapper>
                      )}

                      {fileType === "pdf" && (
                        <iframe
                          src={selectedPhoto.file}
                          className="w-[80vw] h-[75vh] rounded-lg border-0 shadow-lg bg-white"
                          title="PDF Preview"
                        />
                      )}

                      {fileType === "video" && (
                        <video
                          controls
                          src={selectedPhoto.file}
                          className="max-h-[75vh] max-w-full rounded-lg shadow-lg"
                        />
                      )}

                      {fileType === "audio" && (
                        <div className="bg-white rounded-2xl p-10 shadow-lg w-full max-w-md text-center">
                          <BsFileEarmarkMusicFill className="text-6xl text-yellow-500 mx-auto mb-6" />
                          <h4 className="font-bold text-lg mb-4">
                            {selectedPhoto.title}
                          </h4>
                          <audio
                            controls
                            src={selectedPhoto.file}
                            className="w-full"
                          />
                        </div>
                      )}

                      {!["image", "pdf", "video", "audio"].includes(fileType) && (
                        <div className="bg-white p-8 sm:p-10 rounded-3xl shadow-xl text-center max-w-md w-full border border-gray-100">
                          <div className={`w-24 h-24 rounded-2xl flex items-center justify-center mx-auto mb-5 shadow-sm ${getFileColorClass(fileType)}`}>
                            {(() => {
                              const IconComp = getFileIconComponent(fileType);
                              return (
                                <IconComp className="text-5xl" />
                              );
                            })()}
                          </div>
                          <h3 className="text-xl font-bold text-gray-800 break-words px-2">
                            {selectedPhoto.title}
                          </h3>
                          <span className="inline-block mt-2 px-3 py-1 bg-gray-100 text-gray-600 text-xs font-semibold rounded-full uppercase tracking-wider">
                            {fileType} Document
                          </span>
                          <p className="text-gray-500 text-xs mt-3 mb-6">
                            This document can be downloaded or opened directly in your office application.
                          </p>
                          <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
                            <button
                              onClick={() => handleDownload(selectedPhoto.file, selectedPhoto.title)}
                              className="w-full sm:w-auto inline-flex items-center justify-center gap-2 bg-blue-600 text-white px-6 py-2.5 rounded-xl hover:bg-blue-700 transition-colors font-bold shadow-md hover:shadow-lg text-sm"
                            >
                              <FiDownload className="text-base" /> Download File
                            </button>
                            <a
                              href={selectedPhoto.file}
                              target="_blank"
                              rel="noopener noreferrer"
                              className="w-full sm:w-auto inline-flex items-center justify-center gap-2 bg-gray-100 text-gray-700 hover:bg-gray-200 px-6 py-2.5 rounded-xl transition-colors font-semibold border border-gray-200 text-sm"
                            >
                              <FiExternalLink className="text-base" /> Open Directly
                            </a>
                          </div>
                          {["excel", "word", "powerpoint"].includes(fileType) && (
                            <div className="mt-4 pt-4 border-t border-gray-100">
                              <a
                                href={`https://view.officeapps.live.com/op/view.aspx?src=${encodeURIComponent(selectedPhoto.file)}`}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="text-xs text-blue-600 hover:text-blue-800 hover:underline inline-flex items-center gap-1 font-medium"
                              >
                                <FiExternalLink className="text-xs" /> View Online in Office Viewer
                              </a>
                            </div>
                          )}
                        </div>
                      )}
                    </>
                  );
                })()}
              </div>
            </div>
          </div>
        )
      }
    </div >
  );
};

const DetailInput = ({ label, value, icon }) => (
  <div className="flex flex-col gap-1">
    <label className="text-[12px] md:text-[14px] text-gray-600 font-semibold flex items-center gap-1.5 pl-0.5">
      {icon && <span className="text-gray-400 text-xs md:text-sm">{icon}</span>}
      {label}
    </label>
    <div className="px-3 py-2 rounded-md text-[13px] font-medium flex items-center min-h-[38px] bg-white border border-[#133A69] shadow-sm hover:shadow-md transition-all">
      {value || <span className="text-gray-400 italic text-[12px]">-</span>}
    </div>
  </div>
);

const DetailTextarea = ({ label, value }) => (
  <div className="flex flex-col gap-1 mb-1">
    <label className="text-[12px] md:text-[14px] text-gray-600 font-semibold pl-0.5">
      {label}
    </label>
    <div className="w-full px-3 py-2.5 rounded-md bg-white border border-[#133A69] shadow-sm text-[13px] text-gray-800 min-h-[70px] max-h-[120px] overflow-y-auto leading-relaxed custom-scrollbar font-medium hover:shadow-md transition-all">
      {value || <span className="text-gray-400 italic text-[12px]">-</span>}
    </div>
  </div>
);

export default ComplaintDetailPage;
